import React from 'react';
import AppHeader from '../AppHeader/AppHeader';
import { useActiveTab } from '@/hooks';
import './AppLayout.css';

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const activeTab = useActiveTab();

  return (
    <div className="app-layout" data-testid="app-layout">
      <AppHeader activeTab={activeTab} />
      <main className="app-layout__content" data-testid="main-content">
        {children}
      </main>
    </div>
  );
};

export default AppLayout;
